'use client'

import { useEffect } from 'react'
import { silenceConsoleInProduction } from '@/lib/utils/logger'

/**
 * Client component that silences console logs in production
 * This should be included in the root layout
 */
export function SilenceConsole() {
  useEffect(() => {
    silenceConsoleInProduction()
  }, [])

  return null
}

